<template>
    <div>
        <app-page-header title="Portfolio" subtitle="We've had the privilege of a diverse range of internal and client projects over the last 12 years. Here are some of our favorites." />
        <div class="portfolio">
            <b-container>
                <div class="wrapper">
                    <a v-for="item in portfolio" :key="item.name" :href="item.link" target="_blank" rel="noreferrer">
                        <b-card :img-src="item.icon" img-top>
                            <b-card-text>{{ item.description }}</b-card-text>
                        </b-card>
                    </a>
                </div>
            </b-container>
        </div>
    </div>
</template>

<script>
import PortfolioData from '@/data/portfolio.json';
import AppPageHeader from '@/components/global/AppPageHeader';

export default {
    name: 'portfolio',

    components: {
        AppPageHeader,
    },

    data() {
        return {
            portfolio: PortfolioData,
        };
    },
};
</script>

<style lang="scss" scoped>
    .portfolio {
        padding: 80px 0;
    }
    .portfolio a {
        color: inherit;
        text-decoration: none;
        display: grid;
    }
    .card .card-img-top {
        max-width: 316px;
        margin-top: 30px;
        margin-bottom: 10px;
        margin-left: auto;
        margin-right: auto;
    }
    .card {
        cursor: pointer;
        border-radius: 5px;
        border-color: transparent;
        box-shadow: 0px 20px 35px rgba(0, 0, 0, 0.08);
        margin-bottom: 33px;
        &:hover {
            border: 1px solid #bebebe;
        }
    }
    .wrapper {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        grid-column-gap: 29px;
    }
    .card-text {
        font-size: 16px;
        line-height: 28px;
        text-align: left;
        color: #17151A;
    }
</style>
